define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var configurationEditRoles = ['Configuration Editor'];
	var configurationRoles = configurationEditRoles.concat(['Configuration Viewer']);
	
	var wbsAdminRoles = ['WBS Admin'];

	csiAccess.addViewRoles({
		"WorkflowAdmin":{
			"WorkflowMgmt":{
				"":access(readOnly(configurationRoles), full(configurationEditRoles), full(wbsAdminRoles))
			},
			"Workflows":{
				"":access(readOnly(configurationRoles), full(configurationEditRoles), full(wbsAdminRoles)),
				"UploadWorkflow":access(full(configurationEditRoles), full(wbsAdminRoles))
			}
		}
	});
});